import React, { Component } from 'react'
import PropTypes from 'prop-types'
import EventsStore from '../../stores/EventsStore'
import { Button, Form, Grid, Header } from 'semantic-ui-react'
import LoadingWrapper from '../../components/LoadingWrapper'
import { inject, observer } from 'mobx-react'
import { withRouter } from 'react-router'
import { Link } from 'react-router-dom'
import moment from 'moment'
import Radio from '../../components/Forms/Radio'
import TextArea from '../../components/Forms/TextArea'

@inject('eventsStore')
@withRouter
@observer
class EventsSubmitScreen extends Component {
  static propTypes = {
    eventsStore: PropTypes.instanceOf(EventsStore),
    match: PropTypes.object,
    history: PropTypes.object
  }

  componentDidMount () {
    const { eventsStore, match, history } = this.props
    if (eventsStore.event && eventsStore.event.id === match.params.eventId) {
      return
    }
    eventsStore.isloading = true
    eventsStore.loadFormEvent(match.params.eventId).then(() => {
      // validate all form entries are valid
      console.log('check is valid')
      const invalidFormEntry = eventsStore.event.forms_entries.find(formEntry => !formEntry.is_valid)
      if (invalidFormEntry) {
        console.log('Invalid', invalidFormEntry)
        // if not valid redirect to editing
        const form = eventsStore.forms.find(form => form.id === invalidFormEntry.form_id)
        history.replace(`/events/event/${match.params.eventId}?formcode=${form.code}&validate=true`)
      }
      eventsStore.event.setSubmitDate(moment())
    })
  }

  handleSubmitEvent = () => {
    const { eventsStore, history } = this.props
    eventsStore.submitEvent().then(() => {
      // redirect to calendar if all good?
      history.push('/calendars')
    })
  }

  render () {
    const { eventsStore } = this.props
    const { event, isLoading, isSaving, forms } = eventsStore
    if (isLoading || !event) {
      return (<><LoadingWrapper loading={isLoading} message='Chargement en cours...' /></>)
    }
    return (
      <>
        <Header as='h1'>Confirmation de soumission d'inspection</Header>
        <LoadingWrapper loading={isSaving} message='Sauvegarde en cours...' />
        <Form>
          <Grid>
            <Grid.Row columns='equal'>
              <Grid.Column>
                <Header as='h3'>Client</Header>
                {event.client.name}
              </Grid.Column>
              <Grid.Column>
                <Header as='h3'>Heure de remise</Header>
                {moment(event.submitted_date).format('HH:mm DD-MM-YYYY')}
              </Grid.Column>
            </Grid.Row>
            <Grid.Row columns='equal'>
              <Grid.Column>
                <Header as='h3'>Adresse</Header>
                {event.clients_addresses_equipment.clients_address.address.fullAddress}
              </Grid.Column>
              <Grid.Column>
                <Form.Group inline>
                  <Radio store={eventsStore} name='event.isConform' value='conform' label='Conforme' />
                  <Radio store={eventsStore} name='event.isConform' value='conformWithException' label='Conforme avec recommandation' />
                  <Radio store={eventsStore} name='event.isConform' value='notConform' label='Non Conforme' />
                </Form.Group>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <Header as='h3'>Heure de l'inspection</Header>
                {moment(event.date_start).format('HH:mm DD-MM-YYYY')}
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <Header as='h3'>Équipement</Header>
                {event.clients_addresses_equipment.equipment.name}
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <Header as='h3'>Formulaires</Header>
                {forms.map(form => form.code).join(', ')}
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <Header as='h3'>Statut inspection</Header>
                {event.statusName}
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <Header as='h3'>Temps restant</Header>
                {event.remainingTime}
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <Header as='h3'>Notes</Header>
                <TextArea store={eventsStore} name='event.notes' rows={5} />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <Button floated='right' as={Link} to={`/events/event/${event.id}`}>Retour</Button>
                <Button primary content='Soumettre' onClick={this.handleSubmitEvent} />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Form>
      </>
    )
  }
}

export default EventsSubmitScreen
